import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Sidebar from "../layout/Sidebar";
import Topbar from "../layout/Topbar";
import JobDetailsDrawer from "../components/JobDetailsDrawer";

function JobDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(false);

  return (
    <div className="app">
      {showSidebar && (
        <div className="overlay show" onClick={() => setShowSidebar(false)} />
      )}

      <Sidebar show={showSidebar} closeSidebar={() => setShowSidebar(false)} />

      <div className="main">
        <Topbar toggleSidebar={() => setShowSidebar((p) => !p)} />
        <div className="page" style={{ padding: 0 }}>
          <JobDetailsDrawer jobId={id} open={true} isPage={true} onClose={() => navigate("/dashboard")} />
        </div>
      </div>
    </div>
  );
}

export default JobDetails;